type ProjectOptions = Parameters<DSHDLib["createProject"]>[0];
type PreviewOptions = Parameters<DSHDLib["getVariableTemplatePreviewURL"]>[0];

export const createDesignHuddleProject = (options: ProjectOptions): Promise<string> =>
  new Promise((resolve, reject) => {
    DSHDLib.createProject(options, (error, { project_id }) => {
      if (error) return reject(error);
      resolve(project_id);
    });
  });

export const getDesignHuddlePreviewUrl = (options: PreviewOptions): Promise<string> =>
  new Promise((resolve, reject) => {
    DSHDLib.getVariableTemplatePreviewURL(options, (error, url) => {
      if (error) return reject(error);
      resolve(url);
    });
  });
